import { render, staticRenderFns } from "./new-travel-request.vue?vue&type=template&id=2b06c1ec"
import script from "./new-travel-request.vue?vue&type=script&lang=js"
export * from "./new-travel-request.vue?vue&type=script&lang=js"
import style0 from "./new-travel-request.vue?vue&type=style&index=0&id=2b06c1ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports